import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import config from '../config';
import { IconLogo } from '../icons/pacolor';
import '../styles/pages/about.scss';
const NAME = config.name;
const AUTHOR = config.AUTHOR;

const PageAbout: FC<{}> = () => {
   return (
      <>
         <Helmet>
            <title>{config.SEO.about.title}</title>
         </Helmet>
         <div className="main-content">
            <div className="container">
               <div className="icon logo fadeInDown">
                  <IconLogo />
               </div>
               <h1 className="title fadeInUp">About {NAME}</h1>
            </div>
            <main className="container zoomIn">
               <h2>What is {NAME}?</h2>
               <p>
                  {NAME} is an open collection of color palettes, created by{' '}
                  <a href={AUTHOR.url} target="blank">
                     {AUTHOR.name}
                  </a>
                  . {NAME} started as a personal small project built to share
                  trendy color combinations between a group of designer friends.
                  The collection scaled up and now being used daily as a handy
                  resources by thousands of people all over the world.{' '}
                  {AUTHOR.name}
                  was created with the goal of celebrating the beauty of colors,
                  and to serve as a go-to resource for color inspiration.
               </p>

               <h2>Who is it for?</h2>
               <p>
                  {NAME} serves thousands of color schemes for many different
                  design and art purposes. The color palettes are being used by
                  graphic designers, artists, illustrators, web developers,
                  fashion designers, marketeers, interior designers, and more.
                  People use
                  {NAME} to get color inspiration and find the perfect palette
                  for their projects. Anyone can save their favorite palettes,
                  manage their personal collection, and have a quick access to
                  copy the color codes.
               </p>

               <h2>Who creates the color palettes?</h2>
               <p>
                  You, the users, are the ones who create the palettes using{' '}
                  {AUTHOR.name}’s palette creator. The collection is open, and
                  everyone can create and submit their own color combination.
                  That’s how we keep {NAME} diverse, colorful, social and
                  inspiring. Each palette is a public property and not owned by
                  a specific creator, nor by {NAME}.
               </p>

               <h2>
                  I created a palette, why doesn’t it show up on {NAME}’s
                  homepage?
               </h2>
               <p>
                  {NAME} is open, but is also curated. It means that all the
                  palettes are hand-picked by {AUTHOR.name}’s curators. Each
                  submission of a color palette is being reviewed to make sure
                  it fits the collection’s goals. Each day, the very best
                  submission is being picked up and will be visible on the
                  homepage in the day after.
               </p>

               <h2>How does the Likes system work?</h2>
               <p>
                  We don’t require signups. That’s how we let anyone use {NAME}
                  and save their favorite palettes instantly with no hassle.
                  When you click on the Like button the palette is being saved
                  on your browser’s “local storage” so you can access it and
                  manage your personal collection without the need of logging in
                  to {NAME}.
               </p>

               <h2>Who founded and runs {NAME}?</h2>
               <p>
                  {NAME} was founded by{' '}
                  <a href={AUTHOR.url} target="blank">
                     {AUTHOR.name}
                  </a>
                  , designer and artist from Tel Aviv who is passioned about
                  colors. Gal runs {NAME} since 2020 with the goal of sharing
                  that passion with the world, and provide a handy resource for
                  designers and artists. You can read more about the creation of
                  {NAME} and how this side project grew up from the idea to the
                  execution. For any feedback, suggestions or partnership
                  opportunities, reach out to <u>not defined</u>.
               </p>
            </main>
         </div>
      </>
   );
};

export default PageAbout;
